module.exports = __webpack_public_path__ + "static/media/1POLICY36.c640075b.jpg";